import { render, staticRenderFns } from "./SBJData.vue?vue&type=template&id=e565e75a&scoped=true&"
import script from "./SBJData.vue?vue&type=script&lang=js&"
export * from "./SBJData.vue?vue&type=script&lang=js&"
import style0 from "./SBJData.vue?vue&type=style&index=0&id=e565e75a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e565e75a",
  null
  
)

export default component.exports